/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  EmailTemplateCategoryListResponseDto,
  EmailTemplateIndustryListResponseDto,
  EmailTemplateTagListResponseDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List active email template categories
 */
export const emailTemplateTaxonomyControllerListCategories = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailTemplateCategoryListResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-template-taxonomy/categories`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getEmailTemplateTaxonomyControllerListCategoriesQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/email-template-taxonomy/categories`,
  ] as const;
};

export const getEmailTemplateTaxonomyControllerListCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmailTemplateTaxonomyControllerListCategoriesQueryKey(orgId, clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>
  > = ({ signal }) =>
    emailTemplateTaxonomyControllerListCategories(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EmailTemplateTaxonomyControllerListCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>
>;
export type EmailTemplateTaxonomyControllerListCategoriesQueryError = unknown;

export function useEmailTemplateTaxonomyControllerListCategories<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
          TError,
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailTemplateTaxonomyControllerListCategories<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
          TError,
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailTemplateTaxonomyControllerListCategories<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List active email template categories
 */

export function useEmailTemplateTaxonomyControllerListCategories<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEmailTemplateTaxonomyControllerListCategoriesQueryOptions(
    orgId,
    clientId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List email template tags
 */
export const emailTemplateTaxonomyControllerListTags = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailTemplateTagListResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-template-taxonomy/tags`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getEmailTemplateTaxonomyControllerListTagsQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/email-template-taxonomy/tags`,
  ] as const;
};

export const getEmailTemplateTaxonomyControllerListTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmailTemplateTaxonomyControllerListTagsQueryKey(orgId, clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>
  > = ({ signal }) =>
    emailTemplateTaxonomyControllerListTags(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EmailTemplateTaxonomyControllerListTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>
>;
export type EmailTemplateTaxonomyControllerListTagsQueryError = unknown;

export function useEmailTemplateTaxonomyControllerListTags<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
          TError,
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailTemplateTaxonomyControllerListTags<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
          TError,
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailTemplateTaxonomyControllerListTags<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List email template tags
 */

export function useEmailTemplateTaxonomyControllerListTags<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListTags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEmailTemplateTaxonomyControllerListTagsQueryOptions(
    orgId,
    clientId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List email template industries
 */
export const emailTemplateTaxonomyControllerListIndustries = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailTemplateIndustryListResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/email-template-taxonomy/industries`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getEmailTemplateTaxonomyControllerListIndustriesQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/email-template-taxonomy/industries`,
  ] as const;
};

export const getEmailTemplateTaxonomyControllerListIndustriesQueryOptions = <
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmailTemplateTaxonomyControllerListIndustriesQueryKey(orgId, clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>
  > = ({ signal }) =>
    emailTemplateTaxonomyControllerListIndustries(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EmailTemplateTaxonomyControllerListIndustriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>
>;
export type EmailTemplateTaxonomyControllerListIndustriesQueryError = unknown;

export function useEmailTemplateTaxonomyControllerListIndustries<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
          TError,
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailTemplateTaxonomyControllerListIndustries<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
          TError,
          Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEmailTemplateTaxonomyControllerListIndustries<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List email template industries
 */

export function useEmailTemplateTaxonomyControllerListIndustries<
  TData = Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
  TError = unknown,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof emailTemplateTaxonomyControllerListIndustries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEmailTemplateTaxonomyControllerListIndustriesQueryOptions(
    orgId,
    clientId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
